import { render, staticRenderFns } from "./Specialised.vue?vue&type=template&id=7b089f3d"
import script from "./Specialised.vue?vue&type=script&lang=js"
export * from "./Specialised.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports